export default __webpack_public_path__ + "static/media/home-bouquet.2a7c15a8.jpg";